import React from 'react'
import { Box } from '../Core'
import { device } from '../../utils'
import { Link } from 'gatsby'
import { Button } from '../../components/Core'

const NextLink = ({ to, children, ...rest }) => (
    <Link to={to}>
        <Button
            arrowRight
            className="border-0 bg-transparent shadow-none text-capitalize py-3"
            css={`
                font-weight: 700
                font-size: 22px;

                line-height: 1.375;
                @media ${device.md} {
                  font-size: 2rem;
                  letter-spacing: -1.2px;
                }
            `}
        >
            {children}
        </Button>
    </Link>
)

export default NextLink
